export default {
  common: {
    clearAll: 'Tümünü temizle',
    restart: 'Yeniden Başlat'
  },
  download: {
    bodyText: "Aşağıdaki indirme bağlantısına tıklayarak %{products}'u indirin",
    bothProducts: 'PlayBase ve/veya Nexus',
    bodyTextFromAcceptInvitation:
      "Süreç biraz zaman alacak. Bu arada, Metrica Sports'u her zamanki gibi kullanmaya devam edebilirsiniz.",
    bodyTextFromDeclineInvitation:
      "Daveti reddettin! Aşağıdaki bağlantıya tıklayarak %{products}'u indir",
    bodyTextFromTrial:
      'Deneme Kurulumunuza Hoş Geldiniz! Kayıtlı e-postanızı kontrol edin ve bir doğrulama bağlantısı alın (istenmeyen posta klasörünü kontrol edin).',
    bodyTitle: 'İndir',
    bodyTitleFromAcceptInvitation: 'Hesabını Değiştiriyoruz',
    bodyTitleFromDeclineInvitation: 'Davet Reddedildi',
    bodyTitleFromTrial: 'Kayıt tamamlandı',
    play2: {
      description:
        'Metrica PlayBase, amatör ve prosumer antrenörler, küçük kulüpler ve bağımsız analistler için tasarlanmış sezgisel bir analiz aracıdır. Performans değerlendirme sürecini basitleştirerek herkes için erişilebilir hale getirir.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    play3: {
      description:
        'Metrica Nexus, kapsamlı performans bilgileri arayan elit analistler ve antrenörler için özel olarak tasarlanmıştır. Gelişmiş araçlar parmaklarınızın ucunda olduğunda, takım stratejilerini geliştirebilir ve başarıyı sürükleyebilirsiniz.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    thanks:
      "Metrica Sports'a kaydolduğunuz için teşekkür ederiz! Denemenize başlamak için %{products}'u indirin."
  },
  error: {
    restart: 'Görünüşe göre hala geliştirmekte olduğumuz bir yere girmeyi deniyorsun...',
    tryAgainMsg:
      'Lütfen tekrar deneyin. Eğer bu hata devam ederse, Metrica Sports destek ekibiyle iletişime geçin'
  },
  verifyEmail: {
    generateLink: "Play'de oturum açarak yeni bir bağlantı oluşturun",
    readyToLogin: "Play'e giriş yapmaya hazırsınız",
    successfully: 'E-posta başarıyla doğrulandı',
    unsuccessfully: 'E-posta doğrulanırken hata oluştu, geçersiz belirteç'
  }
}
